// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1AXmO","badges":"styles_badges__3pjVh"};